import axios from "axios";
import qs from "qs";
import contentType from "./content-type";
import router from "@/router";
import { getToken } from "@/utils/auth.js";
import { Message } from "element-ui";

import { showFullScreenLoading, tryHideFullScreenLoading } from "./loading";

let baseURL = process.env.VUE_APP_BASE_API;
let uploadURL = process.env.VUE_APP_UPLOAD_URL;

axios.defaults.baseURL = baseURL;

axios.interceptors.request.use(
  config => {
    let token = getToken();
    token && (config.headers["user_token"] = token);

    if (config.headers.needLoading === undefined) {
      showFullScreenLoading();
    }

    return config;
  },
  error => {
    tryHideFullScreenLoading();

    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    return response;
  },
  error => {
    tryHideFullScreenLoading();
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (getToken()) {
            Message({
              message: "已过期，请重新登录",
              type: "error",
              duration: 5000
            });
            sessionStorage.clear();
            router.push("/");
          }
          break;
        default:
      }
      return Promise.reject(error.response.data);
    } else {
      if (!navigator.onLine) {
        Message({
          message: "已过期，请重新登录",
          type: "error",
          duration: 5000
        });
      }
    }
  }
);

/**
 * get
 * @param {String} url
 * @param {Object} params
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * get
 * @param {String} url
 * @param {Object} params
 */
export function getNoloading(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: {
          needLoading: false
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * get
 * @param {String} url
 * @param {Object} params
 */
export function getUrlAppendId(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url + "/" + params.id)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * post
 * @param {String} url
 * @param {Object} params
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      responseType: params.responseType || "",
      url: url,
      headers: params.headers || {
        "Content-Type": contentType.json
      },
      data: params.headers ? qs.stringify(params.data) : params.data
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * get
 * @param {String} url
 * @param {Object} params
 */
export function postNoloading(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url,
      headers: {
        needLoading: false
      },
      data: params.data
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * post
 * @param {String} url
 * @param {Object} params
 */
export function postUrlAppendId(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url + "/" + params.data.id,
      headers: params.headers || {
        "Content-Type": contentType.json
      }
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * post
 * @param {String} url
 * @param {Object} params
 */
export function postForm(url, params) {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url,
      headers: {
        "Content-Type": contentType.fileData
      },
      data: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
